import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { PrismAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Button } from "aible";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { getDraftQueryPreview } from "containers/Relation/reducer";
const QueryPreview = ({ datasetId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [query, setQuery] = useState();
    const dispatch = useDispatch();
    return (React.createElement("div", null,
        React.createElement("div", { style: { display: "flex", justifyContent: "center" } },
            React.createElement(Button, { onClick: () => {
                    setIsLoading(true);
                    dispatch(getDraftQueryPreview(datasetId))
                        .then(setQuery)
                        .finally(() => setIsLoading(false));
                } }, "Load Query Preview")),
        isLoading ? (React.createElement(LoadingIndicator, null)) : query !== undefined ? (React.createElement("div", null,
            React.createElement(SyntaxHighlighter, { language: "sql", style: oneLight, wrapLongLines: true, 
                //Lines aren't actually wrapping, so we're using this hack
                lineProps: { style: { wordBreak: "normal", whiteSpace: "pre-wrap" } }, wrapLines: true }, query))) : (React.createElement("div", null))));
};
export default QueryPreview;
